<template>
    <div id="videobox" class="call">
        <!-- 运营商 -->
         <div class="call-item">
             <li class="headSelect">
                <a href="JavaScript:;">{{softPhoneType|serviceName}}</a>
                <ul class="clearfix">
                    <li v-for="item in serviceList" :key='item.softPhoneType'>
                        <a href="javascript:;" @click="chooseService(item.softPhoneType)">{{item.softPhoneType|serviceName}}</a>
                    </li>
                </ul>
            </li>
        </div>
         <!--  外呼主体-->
        <div class="call-item">
            <input class="phone" type="number" v-model="calledNum" >
            <span class="iconfont simSpan" :class="isCalling?'':'bcg'"
                style="color:white" @click="softPhoneMakeCall">&#xe633;</span>
            <span class="iconfont simSpan"  :class="isCalling?'bcr':''"
                style="color:white" @click="softPhoneHungUp">&#xe637;</span>

        </div>
        <!-- 在线状态 -->
        <div class="call-item">
            <li class="headSelect myState">
                <a href="JavaScript:;"><span class="myState_on"></span>{{onlineStatusList[onlineStatusIndex]}}</a>
                <ul class="clearfix">
                    <li v-for="(value,i) in onlineStatusList" :key="value" >
                        <a href="javascript:;" @click="chooseOnlineStatus(i)" ><span class="myState_on"></span>{{value}}</a>
                    </li>
                </ul>
            </li>


        </div>

<!--        <div class="call-item" style="color:red;" @click="zmqr">-->
<!--            签入-->
<!--        </div>-->
<!--        <div class="call-item" style="color:red;" @click="zmhc">-->
<!--            打电话-->
<!--        </div>-->
<!--        <div class="call-item" style="color:red;" @click="gqm">-->
<!--            挂断-->
<!--        </div>-->

    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import {getAvailablePhoneServices,updateUserOnlineStatus,
            softPhoneMakeCall,softPhoneHungUp,getUserOnlineStatus,getCallState} from "@/utils/api-im"
    export default {
        name: "index",
        data(){
            return{
                calledNum:'',//将要呼叫的电话号码
                softPhoneType:"",
                serviceList:[],//运营商列表
                isCalling:false,//是否在通话中
                timer:"",
                cti:new ClassXnCtiClient(),
                timerList:[],
                basicPar:{},
                onlineStatus:"",//在线状态
                onlineStatusList:["空闲","忙碌","离线","通话中"],//在线状态列表
                onlineStatusIndex:0,//记录在线状态的下标
            }
        },
        computed:{
            ...mapGetters('im',{
                navbardata:'currentUser'
            })
        },
        filters:{
            //过滤运营商名
            serviceName(val){
                //1 七陌 3 众麦 4 容联通讯 5 融营 6 众联（学缘） 7智博 9 科天云 10云朵CTI
                switch(val){
                    case "1":
                        return "QM";
                        break;
                    case "3":
                        return "ZM";
                        break;
                    case "4":
                        return "RL";
                        break;
                    case "5":
                        return "RY";
                        break;
                    case "6":
                        return "ZL";
                        break;
                    case "7":
                        return "ZB";
                        break;
                    case "9":
                        return "KTY";
                        break;
                    case "10":
                        return "YD";
                        break;

                }
            }
            //过滤在线状态
        },
        methods:{
            //初始化参数
             initPar(){
                 //
                 console.log("数据初始化")
                let {companyId, id}=this.navbardata.user;
                    this.basicPar={
                    companyId,
                    "userId":id
                }
            },
            //KTY
            initKTY(){
                //初始化
                    let config={
                        uname: 'pengfei@yunduo.com',
                        pwd: '123456',
                        debug: true,
                        isAutoAnswer: true,
                        forceAnswerWhenRing: true,
                        autoReady: true,
                        stateListenerCallBack: this.fooKTY,
                    }
                CallHelper.init(config,(res)=>{
                    console.log(res,"科天云初始化")
                });

            },
            readyKTY(){
                 //签入
                CallHelper.register((res)=>{
                    console.log(res,"签入成功")
                    CallHelper.ready((res)=>{
                        console.log(res,"坐席成功")
                    });
                })

            },
            hangupKTY(){
                CallHelper.hangup((res)=>{
                    console.log(res,"挂断")
                    this.updateUserOnlineStatus(1,true)
                })
            },
            inviteKTY(pnumber){
                 //外呼
                 //19920100824
                this.timer = setInterval(this.getKtyCallState, 2000);
                console.log(22)
                CallHelper.invite(17863954603, (res)=>{
                    console.log(res,"呼叫成功")
                });
            },
            fooKTY(data){
                //可天云判断通话状态
                if(data.msg=="ANSWERED"){
                    this.isCalling=true;
                    this.updateUserOnlineStatus(4,true)
                }else if(data.msg === "HANGUP"){
                    this.isCalling=false;
                    console.log("已然挂断",this.isCalling)
                    this.updateUserOnlineStatus(1,true)

                }
            },
            //七陌
            qqm(){
                let loginName="8001@lhsjhd",
                    password="1234Aabcd8001",
                    loginType="gateway",
                    agentStatus= 0
                moorCall.moortools.m7BeginLogon("8001@lhsjhd","1234Aabcd8001","gateway", "0");
                //8001@lhsjhd 1234Aabcd8001 gateway 0
            },
            dqm(){
                softphoneBar.dialout(17863954603)
                //m7Phone.dialout(phoneNum);
            },
            gqm(){
                phone.hangup()
            },
            //众麦
            zmqr(){
                // var cti_server = 'cc185.salescomm.net';//cti服务器ip
                // var cti_port = '5335';//cti服务器端口
                getctiserver(callbackFunc); //获取cti服务器地址和端口
                getregserver(callbackFunc2); //获取reg服务器地址和端口
                function callbackFunc() {//回调函数
                    cti.CtiConnect(cti_server, cti_port);//连接cti服务器
                }
                function callbackFunc2() {//回调函数
                    initUA();//注册分机
                    }

                function initUA() {
                    console.log(extensionpwd)
                    var configuration = {
                        wsServers: ws_type + '://' + sip_server + ':' + sip_port + '/ws',
                        uri:"8200696001" + '@' + sip_server + ":" + sip_port,
                        password:"aa123456",
                        authorizationUser: "8200696001",
                        iceCheckingTimeout: 1000,
                        wsServerMaxReconnection: 2,
                        wsServerReconnectionTimeout: 3,
                        connectionrecoverymaxinterval: 3
                    };
                    console.info(configuration);
                    if (ua != null) {
                        ua.stop();
                        ua = null;
                    }
                    ua = new SIP.UA(configuration);
                    ua.on('registered', function (e) {
                        console.log("## 分机注册成功");
                    });

                    ua.on('unregistered', function (e) {
                        console.log(e,"## 分机注册失败");
                    });

                    ua.on('registrationFailed', function (e) {
                        console.log("## 分机注册失败");
                    });
                    ua.on('connected', function (e) {
                    });
                    ua.on('disconnected', function (e) {
                    });
                    ua.on('invite', function (incomingSession) { //coming call
                        console.info(incomingSession);
                        if (session != null) {
                            incomingSession.terminate();
                            return;
                        }
                        session = incomingSession;

                        SessionBindEvent(session);

                        session.accept({//应答
                            media: {
                                constraints: {
                                    audio: true,
                                    video: false
                                },
                                render: {
                                    remote: remoteView,
                                    local: selfView
                                }

                            }
                        });

                    });
                }
                cti.CTIConnectedEvent = function () {//cti服务器连接成功事件
                    console.log(cti_server, cti_port)
                    cti.AgentLogin(agentid, agentpwd, extensionpwd, "820069"); //登录到cti
                }
            },
            zmhc(){
                 console.log(2)
                cti.MakeCall("17863954603", 3, "");
                 console.log(4)
                handcall=1;
            },
            zmgd(){
                cti.Hangup();
            },
            zmstatus(){
                cti.GetAgentState()
            },
            //初始化外呼设备
            getAvailablePhoneServices(){
                console.log(this.softPhoneType)
                // let {companyId, id}=this.navbardata.user,
                    let data={
                        "companyId":"20124",
                        "userId":"103841",
                    };
                this.$post(`http://uctcrm.yunduoketang.cn/${getAvailablePhoneServices}`,data).then((res)=>{
                    console.log(res,"电话初始化返回值")
                    this.serviceList=res.data.object;
                    this.softPhoneType=this.serviceList[0].softPhoneType;
                    if(this.softPhoneType==4){this.setwork();}
                })
            },
            //容联外呼时需要先设置坐席上班
            setwork(){
                let work=`/softPhone/ronglian/setwork`;
                //上班需要设置state=10;
                let {ronglian_accountSid,ronglian_auth_token,ronglian_base_url,ronglian_seat_no,ronglian_appid}=this.service;
                    let data={
                        ronglian_accountSid,
                        "appId": ronglian_appid,
                        ronglian_auth_token,
                        ronglian_base_url,
                        "agentId":ronglian_seat_no,
                    }
                let basicPar={
                        "companyId":"20124",
                        "userId":"103841",
                        state:10
                    }
                Object.assign(data,basicPar)
                this.$post(`http://uctcrm.yunduoketang.cn/${work}`,data).then((res)=>{
                    console.log(res,"","上班吗")
                })
            },
            //融营设置坐席上班
            setworkRY(){
                let work=`/softPhone/rongying/setwork`;
                 let {rongying_accountSid,rongying_app_auth_token,rongying_base_url,rongying_tel_seat_no,rongying_appid}=this.service;
                let data={
                    rongying_accountSid,
                    rongying_app_auth_token,
                    "appId": rongying_appid,
                    rongying_base_url,
                    "agentId": rongying_tel_seat_no,
                }
                let basicPar={
                    "companyId":"20124",
                    "userId":"103841",
                    state:10
                }
                Object.assign(data,basicPar)
                this.$post(`http://uctcrm.yunduoketang.cn/${work}`,data).then((res)=>{
                    console.log(res,"","上班吗ry")
                })
            },
            //外呼
            softPhoneMakeCall(){
                let {companyId, id}=this.navbardata.user,
                    basicPar={
                        "companyId":"20124",
                        "userId":"103841",
                        "softPhoneType":this.softPhoneType,
                        "calledNum":this.calledNum,
                    };
                //根据不同的运营商，上传不同的参数
                let data,index;
                switch(this.softPhoneType){
                    case "9":
                        this.inviteKTY(this.calledNum)
                        return;
                    case "7" :
                        console.log("1")
                        index=this.getIndex(7);
                        let {zhibo_accountNo,zhibo_account_pwd,zhibo_base_url,zhibo_tel_seat_no}=this.serviceList[index];
                        data={
                            zhibo_accountNo,
                            zhibo_account_pwd,
                            zhibo_base_url,
                            zhibo_tel_seat_no
                        };
                        Object.assign(data,basicPar);
                        break;
                    case "4" :
                           console.log("2")
                         index=this.getIndex(4);
                        let {ronglian_accountSid,
                            ronglian_auth_token,
                            ronglian_base_url,
                            ronglian_seat_no,
                            ronglian_appid}=this.serviceList[index];
                        data={
                            ronglian_accountSid,
                            ronglian_auth_token,
                            ronglian_base_url,
                            ronglian_seat_no,
                            ronglian_appid
                        };
                        Object.assign(data,basicPar)
                        break;
                    case "5" :
                     console.log("3")
                        index=this.getIndex(5);
                        let {
                            rongying_accountSid,
                            rongying_app_auth_token,
                            rongying_appid,
                            rongying_base_url,
                            rongying_bind_number,
                            rongying_call_mode,
                            rongying_tel_seat_no
                            }=this.serviceList[index];

                            data={
                                rongying_accountSid,
                                rongying_app_auth_token,
                                rongying_appid,
                                rongying_base_url,
                                rongying_bind_number,
                                rongying_call_mode,
                                rongying_tel_seat_no
                            };
                            Object.assign(data,basicPar)
                            break;
                        case "6" :
                            index=this.getIndex(6);
                            let {xueyuan_account_pwd,
                                xueyuan_base_url,
                                xueyuan_accountNo,
                                xueyuan_tel_seat_no,
                                }=this.serviceList[index];
                            data={
                                xueyuan_account_pwd,
                                xueyuan_base_url,
                                xueyuan_accountNo,
                                xueyuan_tel_seat_no,
                            };
                            Object.assign(data,basicPar)
                            break;
                        case "10" :
                            index=this.getIndex(10);
                            let {yunduocti_account_pwd,
                                yunduocti_accountNo,
                                yunduocti_tel_seat_no,
                                yunduocti_base_url,
                                }=this.serviceList[index];
                            data={
                              yunduocti_account_pwd,
                                yunduocti_accountNo,
                                yunduocti_tel_seat_no,
                                yunduocti_base_url,
                            };
                            Object.assign(data,basicPar)
                            break;
                    }
                this.$post(`http://uctcrm.yunduoketang.cn${softPhoneMakeCall}`,data).then((res)=>{
                    console.log(res,"外呼电话返回值")
                    if(res.data.status=="SUCCESS"){
                        if(this.timerList.length==0){
                            this.timer = setInterval(this.getCallState, 2000);
                            this.timerList.push(this.timer)
                        }else{
                            console.log("别瞎点")
                        }
                    }

                })
            },
            //挂机
            softPhoneHungUp(){
                 let {companyId, id}=this.navbardata.user;
                 let basicPar={
                    "companyId":"20124",
                    "userId":"103841",
                    "softPhoneType":this.softPhoneType,
                    "callId":this.calledNum,
                }
                let data,index;
                 console.log(this.softPhoneType,"??")
                switch(this.softPhoneType){
                    case "9" :
                        this.hangupKTY();
                        return;
                    case "7" :
                        index=this.getIndex(7);
                        let {zhibo_accountNo,zhibo_account_pwd,zhibo_base_url,zhibo_tel_seat_no}=this.serviceList[index];
                        data={
                            zhibo_accountNo,
                            zhibo_account_pwd,
                            zhibo_base_url,
                            zhibo_tel_seat_no
                        };
                        Object.assign(data,basicPar);
                        break;
                    case "4" :
                         index=this.getIndex(4);
                        let {ronglian_accountSid,
                            ronglian_auth_token,
                            ronglian_base_url,
                            ronglian_seat_no,
                            ronglian_appid}=this.serviceList[index];
                        data={
                            ronglian_accountSid,
                            ronglian_auth_token,
                            ronglian_base_url,
                            ronglian_seat_no,
                            ronglian_appid
                        };
                        Object.assign(data,basicPar)
                        break;
                    case "5" :
                        index=this.getIndex(5);
                        let {
                            rongying_accountSid,
                            rongying_app_auth_token,
                            rongying_appid,
                            rongying_base_url,
                            rongying_bind_number,
                            rongying_call_mode,
                            rongying_tel_seat_no
                            }=this.serviceList[index];
                            data={
                                rongying_accountSid,
                                rongying_app_auth_token,
                                rongying_appid,
                                rongying_base_url,
                                rongying_bind_number,
                                rongying_call_mode,
                                rongying_tel_seat_no
                            };
                            Object.assign(data,basicPar)
                            break;
                        case "6" :
                            index=this.getIndex(6);
                            let {xueyuan_account_pwd,
                                xueyuan_base_url,
                                xueyuan_accountNo,
                                xueyuan_tel_seat_no,
                                }=this.serviceList[index];
                            data={
                                xueyuan_account_pwd,
                                xueyuan_base_url,
                                xueyuan_accountNo,
                                xueyuan_tel_seat_no,
                            };
                            Object.assign(data,basicPar)
                            break;
                        case "10" :
                            index=this.getIndex(10);
                            let {yunduocti_account_pwd,
                                yunduocti_accountNo,
                                yunduocti_tel_seat_no,
                                yunduocti_base_url,
                                }=this.serviceList[index];
                            data={
                              yunduocti_account_pwd,
                                yunduocti_accountNo,
                                yunduocti_tel_seat_no,
                                yunduocti_base_url,
                            };
                            Object.assign(data,basicPar)
                            break;
                }
                 this.$post(`http://uctcrm.yunduoketang.cn${softPhoneHungUp}`,data).then((res)=>{
                     clearInterval(this.timer);
                     console.log(this.timer,"?")
                     this.isCalling=false;
                     this.updateUserOnlineStatus(2,false)
                     console.log(res,"gj")
                })
            },
            //获取用户在线状态
            getUserOnlineStatus(){
                let basicPar={
                    "companyId":"22553",
                    "userId":"108450",
                    "softPhoneType":this.softPhoneType,
                }
                this.$post(`http://uctcrm.yunduoketang.cn${getUserOnlineStatus}`,basicPar).then((res)=>{
                     console.log(res.data.object,"获取用户在线状态")
                     this.onlineStatus=res.data.object
                     //1 空闲 2 忙碌 3 离线 4 通话中
                })
            },
            //获取通话状态
            getCallState(){
                 let basicPar={
                    "companyId":"22553",
                    "userId":"108450",
                    "softPhoneType":this.softPhoneType,
                }
                let data,index;
                switch(this.softPhoneType){
                    case "4" :
                        index=this.getIndex(4);
                        let {ronglian_appid}=this.serviceList[index];
                        data={"appId":ronglian_appid};
                        Object.assign(data,basicPar)
                        break;
                    case "5" :
                        index=this.getIndex(5);
                        let {rongying_appid}=this.serviceList[index];
                        data={"appId":rongying_appid};
                        Object.assign(data,basicPar)
                        break;
                    case "6" :
                        index=this.getIndex(6);
                        let {xueyuan_accountNo,xueyuan_seat_no}=this.serviceList[index];
                        data={xueyuan_accountNo,xueyuan_seat_no};
                        Object.assign(data,basicPar)
                        break;
                    case "7" :
                        index=this.getIndex(7);
                        let {zhibo_accountNo,zhibo_seat_no}=this.serviceList[index];
                        data={zhibo_accountNo,zhibo_seat_no};
                        Object.assign(data,basicPar)
                        break;
                    case "10" :
                        index=this.getIndex(7);
                        let {yunduocti_accountNo,yunduocti_seat_no}=this.serviceList[index];
                        data={yunduocti_accountNo,yunduocti_seat_no};
                        Object.assign(data,basicPar)
                        break;
                }
                this.$post(`http://uctcrm.yunduoketang.cn${getCallState}`,data).then((res)=>{
                     console.log(res.data.object,"获取通话状态")
                     this.isCalling=res.data.object;
                    //如果挂断电话 停止定时器
                    //  if(){
                    //     clearInterval(this.timer);
                    //     this.isCalling=false;
                    //  }
                })
            },
            //更新用户在线状态接口。1、用户手动变更状态时调用2、通过js外呼时调用，将用户在线状态置为4（通话中）
            updateUserOnlineStatus(satatus,boolean){
                //changeByCall
                 let data={
                    "companyId":"22553",
                    "userId":"108450",
                    status
                }
                if(boolean){Boolean.changeByCall=true;}
                this.$post(`http://uctcrm.yunduoketang.cn${updateUserOnlineStatus}`,data).then((res)=>{
                     console.log(res.data.object,"获取通话状态")

                })
            },
            //切换运营商
            chooseService(softPhoneType){
               this.softPhoneType=softPhoneType;
               if(softPhoneType==4){this.setwork();}
            //    if(softPhoneType==5){this.setworkRY()}
                if(softPhoneType==9){this.readyKTY();}
            },
            //切换在线状态
            chooseOnlineStatus(value){
                this.onlineStatusIndex=value;
                this.updateUserOnlineStatus(value++,false)
            },
            //
            getIndex(val){
                for(let i=0;i<this.serviceList.length;i++){
                    if(this.serviceList[i].softPhoneType==val){
                        return i
                    }
                }

            }
        },
        mounted() {
            //测试时可能有，实际上组件第一次加载时需要监听获取
            console.log(this.$store.state.im.userMsg.jwtToken,"ymyxxx")
            this.getAvailablePhoneServices();
            this.getUserOnlineStatus();
            this.initPar();
            this.initKTY();
        }
    }
</script>
<style scoped lang="less">
    .call{
        height: 60px;
        .call-item{
            float: left;
        }
        .call-item-1{
             width: 45px;
            text-align: center;
            color: white;
            .rela{
                position: fixed;
                top: 20px;
                z-index: 100;
            }
        }
    }
    .phone{
        border: 1px solid white;
        width: 120px;
        height: 26px;
        padding: 0 0px 0 10px;
        border-radius: 4px;
        color: #666;
    }
     .headSelect {
            &>a {
                color: white;
                padding: 5px 10px;
                height: 20px;
                width: 45px;
                line-height: 20px;
                border-radius: 6px;
                text-align: center;
                display: inline-block;

            }

            ul {
                background: #24252a;
                position: absolute;
                top: 60px;
                display: none;
                z-index: 999;

                li {
                    width: 68px;
                    height: 30px;
                    padding: 0 0 0 20px;
                    background: #1b1b1b;
                    line-height: 30px;
                    text-align: left;
                    color: white;
                    clear: left;

                    a {
                        display: inline-block;
                        width: 100%;
                        line-height: 30px;
                        color: #fff;
                    }

                    &:hover a{
                        color: #0099ff;
                    }
                }
            }

            &:hover ul {
                display: block;
            }
        }
        // 在线状态
        .myState {
            &>a {
                border: none;
                width: 50px;
                margin-left: 6px;
            }
            span {
                width: 12px;
                height: 12px;
                display: inline-block;
                border-radius: 50%;
                vertical-align: middle;
                margin-right: 8px;
            }

            .myState_on {
                background-color: #009933;
            }

            .myState_off {
                background-color: #fc0304;
            }
        }
        .simSpan{
            display: inline-block;
            text-align: center;
            width: 30px;
            height: 18px;
            line-height: 18px;

            border-radius: 4px;
            border-top: 1px solid #aaaaaa;
            border-bottom: 1px solid #aaaaaa;
            background-color: #AAAAAA;
        }
        .bcg{
             border-top: 1px solid green;
            border-bottom: 1px solid green;
            background-color: green;
        }
        .bcr{
             border-top: 1px solid red;
            border-bottom: 1px solid red;
            background-color: red;
        }
</style>




// WEBPACK FOOTER //
// src/components/call/index.vue